import React from 'react';
import Pillbox from '@dtci/spellbook/Pillbox';
import { roleMapping } from '../../../utils/userRoles';

export const PillboxCellRenderer = () => {
    const Renderer = ({ data }) => {
        if (!Array.isArray(data?.spaUserRoleIds) || data?.spaUserRoleIds.length === 0) return null;

        const roles = data.spaUserRoleIds
            .map((id) => roleMapping.find((r) => r.id === id))
            .filter(Boolean);

       return (
           <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px', padding: '8px 0' }}>
               {roles.map((role, idx) => (
                   <Pillbox
                       key={role.id || idx}
                       badgeRole="listitem"
                       color="primary"
                       light
                       showClose={false}
                       size="small"
                   >
                       {role.roleName || role.id}
                   </Pillbox>
               ))}
           </div>
       );
    };
    return Renderer;
};
